import { SearchingPage } from "../pages";

export const SearchRoutes = [
  {
    path: ':search',
    element: (
      <SearchingPage />
    ),
  },
];
